import { type AxiosInstance } from 'axios'
import { useMutation } from '@tanstack/react-query'
import { type IUserStorage } from '../../../services/utils/local-storage'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { mixpanelInstance } from '@utils/mixpanel'

export type UseLogoutArgs = {
  apiClient: AxiosInstance
  savedUser: IUserStorage
}

export function useLogout({ savedUser, apiClient }: UseLogoutArgs) {
  const { pathname } = useLocation()
  const queryClient = useQueryClient()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  async function logout() {
    const refreshToken = savedUser.getRefresh()

    if (refreshToken) {
      await apiClient.post('v2/auth/jwt/logout', {
        refresh_token: refreshToken
      })
    } else {
      return Promise.resolve()
    }
  }

  function onSuccessfulLogout() {
    queryClient.removeQueries({ queryKey: ['me'] })
  }

  function onLogoutSettled() {
    setSearchParams((prev) => {
      prev.set('redirect', pathname.toString())
      return prev
    })
    navigate(`/login/?${searchParams.toString()}`, { replace: true })
    savedUser.clear()
    mixpanelInstance.logout()
    queryClient.clear()
  }

  return useMutation({
    mutationFn: logout,
    onSuccess: onSuccessfulLogout,
    onSettled: onLogoutSettled
  })
}
